import React from 'react';
import { Paper, Typography } from '@mui/material';

import { EditCancelBar, useEditCancelBarControlRef } from '../controls/EditCancelBar';

interface Props<T> {
  readonly pluralNoun: string;
  readonly list: { readonly guid: string };
  readonly defaultListGuid: string | null;
  onChange(changes: Partial<T>): void;

  readonly disableSubmission?: boolean;
  readonly changesHaveBeenMade: boolean;

  onSubmit(): Promise<void>;
  onSetAsDefaultList(): Promise<void>;
  navigateAfterSubmit(): void;
  onCancel?: () => void;
}

export function ListForm<T>(props: Props<T>) {
  const buttonBarControlRef = useEditCancelBarControlRef();

  const isDefaultListGuid = props.list.guid === props.defaultListGuid;
  const defaultListHasChanged = isDefaultListGuid !== (props.list.guid === props.defaultListGuid);

  return (
    <Paper
      elevation={0}
      sx={{
        p: 2,
        width: '100%',
        justifyContent: 'space-between',
        alignItems: 'baseline',
        flexWrap: 'wrap',
      }}
    >
      <Typography variant="body2" color="textSecondary" gutterBottom>
        Choose what {props.pluralNoun} should be included in this list by selecting or deselecting options in the grid.
      </Typography>
      <EditCancelBar
        disabled={props.disableSubmission || (!props.changesHaveBeenMade && !defaultListHasChanged)}
        controlRef={buttonBarControlRef}
        onSubmit={async () => {
          if (props.changesHaveBeenMade) {
            await props.onSubmit();
          }

          if (defaultListHasChanged) {
            await props.onSetAsDefaultList();
          }

          await props.navigateAfterSubmit();
        }}
        onCancel={props.onCancel}
      />
    </Paper>
  );
}
